import { BoxSetItemModel } from './box-set-item.model';

export class ProductBoxSetModel {
  public id: number = null;
  public boxSetItem: BoxSetItemModel = new BoxSetItemModel();
  uuid: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
